// components/SidebarNav.jsx
import { NavLink } from 'react-router-dom';

const links = [
    { path: '/',            label: 'Home' },
    { path: '/experience',  label: 'Experience' },
    { path: '/projects',    label: 'Projects' },
    { path: '/library',     label: 'Library' },
    { path: '/contact',     label: 'Contact' },
    { path: '/inspo',       label: 'Inspo' },
];

export default function SidebarNav() {
    return (
        <nav className="sidebar">
            <ul>
                {links.map(({ path, label }) => (
                    <li key={label}>
                        <NavLink
                            to={path}
                            end={path === '/'}
                            className={({ isActive }) => (isActive ? 'active' : undefined)}
                            aria-label={label}
                        >
                            {({ isActive }) => (
                                isActive
                                    ? <span className="sidebar-dot" aria-hidden="true" />
                                    : label
                            )}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
